import React, { Component } from "react";
// import axios from "axios"
import DashMenu from "../../part/dash_menu";
// import HeaderDashboard from "../../part/header.dashaboard";
import FooterDashboard from "../../part/footer.dashboard";
import Read from "../../image/reading.jpeg"
import { Link } from "react-router-dom";
import axios from "axios";
import DashScrollCourse from "../../part/dash.course.scroll";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import LoadingError from "../../part/loading_error";


import { PiNetworkX } from "react-icons/pi";
import Internet from "../../image/internet.jpeg"



class Dashboard extends Component {
  state = {
    menuCoverWidth: this.getInitialMenuCoverWidth(),
    windowHeight: window.innerHeight - 60,
    isActive: false,
    courses: [],
    // accessToken: null,
    user: {  // Initialize user as an object with default values
      name: '',
      email: '',
      role: ''
    },
    // isLoading: true,
    // error: null,
    isContactVisible: false,
    loading: false,
    network: false
  }
  getInitialMenuCoverWidth() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 900) {
      return 0;
    } else if (windowWidth >= 900 && windowWidth < 1200) {
      return 60;
    } else {
      return 260;
    }
  }



  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover")
      formdisplay.style.display = "none"
    }

  };

  handleAddCourses = () => {
    const formcontainer = document.querySelector(".dash_add_course_cover")
    formcontainer.style.display = "flex"
  }


  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
    this.fetchCourses();

    const storedUser = localStorage.getItem('user');

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        console.log("User data:", user);
        this.setState({ user: user })
      } catch (error) {
        console.error("Error parsing user data:", error);
        localStorage.removeItem('user');
      }
    }
    // const storedToken = localStorage.getItem('accessToken');
    // const storedUser = localStorage.getItem('user');

    // if (!storedToken || !storedUser) {
    //   window.location.href = '/login';
    //   return;
    // }
    // try {
    //   const user = JSON.parse(storedUser);
    //   this.setState({ accessToken: storedToken, user: user, isLoading: false }); // Set user in state

    //   if (user.role !== 'student') {
    //     this.setState({ error: "You do not have permission to access this page." });
    //   }
    // } catch (error) {
    //   console.error("Error parsing user data:", error);
    //   this.setState({ error: "Error loading user data.", isLoading: false });
    //   localStorage.removeItem('accessToken');
    //   localStorage.removeItem('user');
    //   window.location.href = '/login';
    // }
  };


  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  fetchCourses = async () => {
    this.setState({ loading: true, network: false })
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      this.setState({ courses: response.data, loading: false });
      console.log("API Response:", response.data);
    } catch (error) {
      if (error.response) {
        // Server responded with a status code
        if (error.response.status === 401) {
          console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          // window.location.href = "/";
        } else {
          console.error("Error response from API:", error.response);
          this.setState({ loading: false });
        }
      } else if (error.code === "ERR_NETWORK") {
        console.error("Network error detected. Possibly no internet or server is down.");
        this.setState({ network: true, loading: false  })
      } else {
        // Any other unexpected error
        console.error("Unexpected error:", error);
        this.setState({ loading: false });
      }
    }
  };



  // to delete courses




  // it ends here 

  handleResize = () => {
    const menuCover = document.querySelector('.dashboard .menu_cover');
    if (menuCover) {
      this.setState({ menuCoverWidth: menuCover.offsetWidth });
    }
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  pre_RecorderedfilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "Online Prerecorded");
  };
  livefilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "Online Live with Facilitator");
  };
  groupfilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "General Physical Class");
  };
  privatefilterData = () => {
    const { courses } = this.state;
    return courses.filter((item) => item.training_type === "Physical Private Class");
  };
  render() {
    // const {translatedText } = this.state;
    const { menuCoverWidth, user, network } = this.state;
    const predata = this.pre_RecorderedfilterData()
    const livedata = this.livefilterData()
    const groupdata = this.groupfilterData()
    const privatedata = this.privatefilterData()
    console.log(this.state)
    return (
      <div className="dashboard" >
        <DashSearchHeader onResize={this.handleResize} />
        <DashMenu />
        <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }} >
          <div className="dash_home_body">
            <div className="dash_home_body_content">
              <h2><span>{user.name},</span> grow your skills and advance your career with Geoinfotech Academy</h2>
              <Link to="/library"><button className="first">My Library</button></Link><Link to="/online_prerecorded"><button>View Courses</button></Link>
            </div>
            <div className="dash_home_body_img">
              <img src={Read} alt="study" />
            </div>
          </div>

          <div className="dash-main-scroll-cover">
            {network ?
              <div className="network_container">
                <div className="image">
                  {/* <PiNetworkX /> */}
                  <img src={Internet} alt="internet"/>
                </div>
                <br />
                <h2>Something Went Wrong<br/> Reload page</h2>
              </div>
              :
              <>
                <DashScrollCourse topics={predata} />
                <DashScrollCourse topics={livedata} />
                <DashScrollCourse topics={groupdata} />
                <DashScrollCourse topics={privatedata} />
              </>
            }
          </div>
          {/* <div className="test"></div> */}

          <FooterDashboard />
          {/* <div className="dashboardfloatcontact" style={{ display: this.state.isContactVisible ? 'inline' : 'none' }}><FloatingContact /></div> */}
          <Policy />
        </div>
        {this.state.loading ? <LoadingError /> : null}
      </div>
    )
  }
}
export default Dashboard